export const config = Object.freeze({
    apiUrl: 'http://127.0.0.1:8000/api',
    Url: 'http://127.0.0.1:8000/'
  });
  
  //167.172.129.238